import React, { FC, useEffect, useMemo, useState } from 'react'
import { THeaderType } from 'components/Header/Header'
// import BadgeWarning from 'ui/Badge'
import styled from 'styled-components'
import StakingPreviewBlock from './components/StakingPreviewBlock'
import SetupButton from '../DropdownPriceAlerts/components/SetupButton'
import StakingPairItem from './components/StakingPairItem/StakingPairItem'

import BTCIcon from '../../components/DropdownBuyCrypto/svg/btc.svg'
import EthIcon from '../../components/DropdownBuyCrypto/svg/eth.svg'
import UsdtTronIcon from '../../components/DropdownBuyCrypto/svg/usdt__tron_trc20.svg'
import UsdcEthIcon from '../../components/DropdownBuyCrypto/svg/usdc__eth_erc20.svg'
import LinkWithLocale from 'components/LinkWithLocale'
import { TFunction } from 'src/providers/TranslateProvider/TranslateProvider'
import useTranslation from 'hooks/useTranslation'
import { BadgeType } from 'src/types'
import { GATSBY_MAIN_URL } from 'constants/env'
import useLocale from 'hooks/useLocale'
import { isEmptyHeaderPage } from '../../../../constants'

const getOptions = (t: TFunction) => [
  {
    name: 'Bitcoin (BTC)',
    earn: t('Earn'),
    url: '',
    percent: t('PERCENT APY', { PERCENT: '3' }),
    badgeType: BadgeType.Hot,
    icon: BTCIcon,
  },
  {
    name: 'Ethereum (ETH)',
    earn: t('Earn'),
    url: '',
    percent: t('PERCENT APY', { PERCENT: '4.7' }),
    badgeType: null,
    icon: EthIcon,
  },
  {
    name: 'Tether (USDT)',
    earn: t('Earn'),
    url: '',
    percent: t('PERCENT APY', { PERCENT: '5' }),
    badgeType: BadgeType.BestOffer,
    icon: UsdtTronIcon,
  },
  {
    name: 'USD Coin (USDC)',
    earn: t('Earn'),
    url: '',
    percent: t('PERCENT APY', { PERCENT: '5' }),
    badgeType: null,
    icon: UsdcEthIcon,
  },
]

interface DropdownStakingProps extends IOwnProps {
  dropdownType:
    | 'app'
    | 'buy crypto'
    | 'futures'
    | 'spot'
    | 'explore trading'
    | 'price alerts'
    | 'staking'
    | 'markets'
    | 'refferal'
}

interface CoinData {
  coinPercent: string
  coinName: string
  coinIcon: JSX.Element
}

const DropdownStaking: FC<DropdownStakingProps> = () => {
  const { t } = useTranslation()
  const { locale, pathname } = useLocale()
  const options = useMemo(() => getOptions(t), [t])

  const [previewCoinData, setPreviewCoinData] = useState<CoinData>({
    coinName: options[0].name,
    coinPercent: options[0].percent,
    coinIcon: options[0].icon,
  })

  const isBlog = isEmptyHeaderPage(pathname)

  useEffect(() => {
    setPreviewCoinData({ coinName: options[0].name, coinPercent: options[0].percent, coinIcon: options[0].icon })
  }, [options])

  const allAssets = locale === 'en' ? `${GATSBY_MAIN_URL}/page/staking` : `${GATSBY_MAIN_URL}/page/${locale}/staking`

  return (
    <DropdownItemGridContainer>
      <ItemWrapper>
        {options.map((item, index) => {
          const l = locale === 'en' ? '' : `${locale}/`
          const to = isBlog ? `/page/${l}staking` : '/staking'

          return (
            <PairContainer
              withLocale
              replace
              to={to}
              key={index}
              onMouseEnter={() =>
                setPreviewCoinData({
                  coinName: item.name,
                  coinIcon: item.icon,
                  coinPercent: item.percent,
                })
              }>
              <StakingPairItem
                isIndicator={false}
                isBadge={item.badgeType}
                isPositive
                percent={item.percent}
                label={item.name}
                text={item.earn}
                trendRange={''}
                coinsRequestName={''}
                tickerLabel={''}
                estimatedAmount={''}
                isError={''}
              />
            </PairContainer>
          )
        })}
        <SetupButton withLocale={false} href={allAssets} label={t('See All Assets')} />
      </ItemWrapper>
      <StakingPreviewBlock
        preview={previewCoinData.coinIcon}
        title={`${previewCoinData.coinName} ${t('on Margex Platform')} ${t('Earn').toLowerCase()}`}
        percentPrefix={previewCoinData.coinPercent}
        buttonLabel={t('Stake and Trade Now')}
        href={'/staking'}
        payout={''}
      />
    </DropdownItemGridContainer>
    //   </Dropdown>
    // </DropdownContainer>
  )
}

export default DropdownStaking

const DropdownItemGridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  row-gap: 0.875rem;
  background: linear-gradient(0deg, #f3f7fd, #f3f7fd), #123482;
  /* box-shadow: 0px 15px 50px rgba(15, 42, 102, 0.7); */
  border-radius: 8px;
`

// const BadgeWarningWrapper = styled(BadgeWarning)`
//   margin-inline-start: 0.5em;
// `
const ItemWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: max-content;
  grid-auto-rows: max-content;
  grid-column-gap: 3rem;
  grid-row-gap: 0.25rem;
  padding: 2rem;
  text-align: start;
  /* padding-bottom: 0; */
`
const PairContainer = styled(LinkWithLocale)`
  width: 250px;
  margin-bottom: auto;
`

interface IOwnProps {
  name?: string
  options: Array<{ name: string; url: string }>
  warning?: string | null
  type: THeaderType
}
